import { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.4 });
  const ref = useRef(null);

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!fine) return;
    setEnabled(true);
    document.body.classList.add("pill-cursor-active");

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = e.target.closest("a,button,input,textarea,select,[role='button'],[data-cursor='hover']");
      setHovering(!!el);
    };
    window.addEventListener("mousemove", move);
    return () => {
      window.removeEventListener("mousemove", move);
      document.body.classList.remove("pill-cursor-active");
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      ref={ref}
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[9999] -translate-x-1/2 -translate-y-1/2"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        animate={{
          width: hovering ? 30 : 42,
          height: hovering ? 30 : 20,
          rotate: hovering ? 90 : 35,
        }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className="flex overflow-hidden rounded-full shadow-[0_4px_14px_rgba(14,165,233,0.4)] ring-1 ring-white/60"
      >
        <div className="h-full w-1/2 bg-blue-brand" />
        <div className="h-full w-1/2 bg-lab-green" />
      </motion.div>
    </motion.div>
  );
}
